gsap.registerPlugin(ScrollTrigger, MorphSVGPlugin);

document.addEventListener('load', init());

function init(){
  initBlogSharePin() // with Pin
  initFadeIn()
  initBG();
}

function initBlogSharePin() {
  if (document.querySelector('article .post-social-wrapper')) {
    ScrollTrigger.matchMedia({

      "(min-width: 421px)": function() {

        ScrollTrigger.create({
          trigger: 'article .post-social-wrapper',
          start: 'top 180px',
          endTrigger: '.inner-article',
          end: 'bottom 350px',
          pin: true,
          // markers: true,
        })
      }
    });
  }
}

function initFadeIn() {

  const elements = document.querySelectorAll('.fade-in');

  if (elements) {
    elements.forEach((el) => {
        gsap.from(el, {
            autoAlpha: 0,
            yPercent: 5,
            scrollTrigger: {
                trigger: el,
                start: 'top 90%',
                end: 'top center',
                // toggleActions: 'play none none reverse',
                // markers: true
            }
        })
    })
  }
}

function initBG() {

  const main = document.querySelector('#main-content');
  const scrollColorElems = document.querySelectorAll("#main-content section");
  const darkGreyText = main.querySelectorAll('.copy, .img-grid .label, .accordion-content');
  const blackText = main.querySelectorAll('h1, h2, h3, h4, h5, h6, .title, .name, .quote, .sample-products, .copy p strong, .feature, .gfield--type-html, .accordion-title, .mission, .wpgb-facet-4');


  if (scrollColorElems) {

    scrollColorElems.forEach((section) => {

      var bgColor = section.classList.contains('dark') ? '#181818' : '#FFFFFF'
      var greyFontColor = section.classList.contains('dark') ? '#F0F0F0' : '#747474'
      var blackFontColor = section.classList.contains('dark') ? '#F0F0F0' : '#161718'

      ScrollTrigger.create({
        trigger: section,
        start: 'top center',
        end: 'bottom center',
        // markers: true,
        onEnter: () => {
          gsap.to(main, {
            backgroundColor: bgColor,
            duration: 0.5,
            ease: 'Power4.easeOut'
          })
          gsap.to(darkGreyText, {
            color: greyFontColor,
            duration: 0.5,
            ease: 'Power4.easeOut'
          }, '-=0.5')
          gsap.to(blackText, {
            color: blackFontColor,
            duration: 0.5,
            ease: 'Power4.easeOut'
          }, '-=0.5')
        },
        onEnterBack: () => {
          gsap.to(main, {
            backgroundColor: bgColor,
            duration: 0.5,
            ease: 'Power4.easeOut'
          })
          gsap.to(darkGreyText, {
            color: greyFontColor,
            duration: 0.5,
            ease: 'Power4.easeOut'
          }, '-=0.5')
          gsap.to(blackText, {
            color: blackFontColor,
            duration: 0.5,
            ease: 'Power4.easeOut'
          }, '-=0.5')
        }
      });
    });
  }
}